
export default () => ({ dashboardNameTextField: { marginBottom: '1rem' } });
